import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import {
  Dialog as MuiDialog,
  DialogContent as MuiDialogContent,
  DialogContentText as MuiDialogContentText,
  DialogActions as MuiDialogActions,
  Button as MuiButton,
} from '@mui/material';
import { CropFree as CropFreeIcon } from '@mui/icons-material';

const defaultValidationError = {
  title: 'Be aware, file exceed the maximum size',
  subtitleFirstPart: 'Please change, or reduce.',
  subtitleSecondPart: 'Size maximum allowed is 10Mb',
};

const ValidationPopup = ({
  onClose,
  open,
  validationError = defaultValidationError,
}) => {
  const { t } = useTranslation();

  return (
    <MuiDialog open={open} onClose={onClose}>
      <SDialogContent>
        <SIconWrapper>
          <CropFreeIcon style={{ fontSize: '96px' }} />
        </SIconWrapper>
        <MuiDialogContentText>
          {validationError ? (
            <>
              <STitle>{t(validationError.title)}</STitle>
              <SSubTitle>
                {t(validationError.subtitleFirstPart)}
                <br />
                {t(validationError.subtitleSecondPart)}
              </SSubTitle>
            </>
          ) : (
            ''
          )}
        </MuiDialogContentText>
      </SDialogContent>
      <SDialogActions>
        <MuiButton
          type="submit"
          variant="contained"
          onClick={onClose}
          color="primary"
        >
          {t('Close')}
        </MuiButton>
      </SDialogActions>
    </MuiDialog>
  );
};

const SDialogContent = styled(MuiDialogContent)`
  padding: 0 50px;
`;

const SIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 40px 0 30px;
`;

const STitle = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 27px;
  text-align: center;
  color: ${({theme}) => theme.palette.colors.black100};
`;
const SSubTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  margin-top: 10px;
  color: ${({theme}) => theme.palette.colors.black100};
  white-space: pre-wrap;
`;
const SDialogActions = styled(MuiDialogActions)`
&& {
  margin: 20px 0;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
}
`;

export default ValidationPopup;
